import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {buildTeammateShortDisplayName} from '../../../../../helpers/modelHelpers';
import {TeammateModel} from '../../../../../models/api/teammateModel';
import {CellAuthorWrapper} from './cellAuthorWrapper';
import {CellSummaryWrapper} from './cellSummaryWrapper';

/*
 * Props.
 */

interface CellConversationSharedProps {
  isSelected?: boolean;
  source: TeammateModel;
}

/*
 * Component.
 */

export const CellConversationShared: FC<CellConversationSharedProps> = (props) => (
  <CellAuthorWrapper author={props.source}>
    <CellSummaryWrapper {...props}>
      <Trans id="cell-bottom-line-conversation-shared">
        <strong>{buildTeammateShortDisplayName(props.source)}</strong> invited you.
      </Trans>
    </CellSummaryWrapper>
  </CellAuthorWrapper>
);
